module.exports = __webpack_public_path__ + "img/logo-bonega.a0f8ff73.svg";